import ClaimTypeDealerAutomationRule from 'models/dealerManagement/claimTypeDealerAutomationRule/Model.ClaimTypeDealerAutomationRule';
import ClaimTypeDealerGroupAutomationRule from 'models/dealerManagement/claimTypeDealerGroupAutomationRule/Model.ClaimTypeDealerGroupAutomationRule';
import Model from 'models/Model';
import ClaimType from '../claimType/Model.ClaimType';

export default class ClaimTypeAutomationRule
  extends Model<Model.IClaimTypeAutomationRule>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimTypeAutomationRule>
{
  id: number;
  logicalLayout: Model.Automation.ILayoutToken[];
  expressions: Model.Automation.IExpression[];
  effects: Model.Automation.IEffect[];

  claimTypeId: number;
  claimType: ClaimType;
  claimTypeDealerAutomationRules: ClaimTypeDealerAutomationRule[];
  claimTypeDealerGroupAutomationRules: ClaimTypeDealerGroupAutomationRule[];

  constructor(
    data: Partial<Model.IClaimTypeAutomationRule> | Utils.FormData<Model.IClaimTypeAutomationRule>,
    language?: Locale.Languages
  ) {
    super(
      {
        claimType: ClaimType,
        claimTypeDealerAutomationRules: [ClaimTypeDealerAutomationRule],
        claimTypeDealerGroupAutomationRules: [ClaimTypeDealerGroupAutomationRule],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id.toString(),
    };
  }
}
